export const sessionTimeOut = "SESSION_TIMEOUT_CHECK";
export const getAccessToken = "GET_ACCESS_TOKEN";
export const getAccessTokenSuccess = "GET_ACCESS_TOKEN_SUCCESS";
export const getAccessTokenFailed = "GET_ACCESS_TOKEN_FAILED";
